import { z } from '@betty/toolkit/api';

const SubTypeMetaSchema = z.object({
  currentAccumulation: z.number(),
  targetAccumulation: z.number(),
  expiryDate: z.string(),
  gameIds: z.array(z.number()).optional(),
  startDate: z.string(),
});

export enum QuestStatus {
  Future = 'Future',
  Available = 'Available',
  Locked = 'Locked',
  OptIn = 'OptIn',
  Completed = 'Completed',
  InProgress = 'InProgress',
}

const QuestStatusEnum = z.nativeEnum(QuestStatus);

export type QuestsMeta = z.infer<typeof SubTypeMetaSchema>;

const RewardSchema = z.object({
  rewardTarget: z.string(),
  rewardAmount: z.number(),
});

export type PromotionReward = z.infer<typeof RewardSchema>;

export const RawQuestSchema = z.object({
  rewardTarget: z.string(),
  rewardAmount: z.number(),
  rewards: z.array(RewardSchema),
  isOptedIn: z.boolean(),
  status: QuestStatusEnum,
  startDate: z.string(),
  endDate: z.string(),
  promotionId: z.number(),
  title: z.string(),
  imageUrl: z.string(),
  isBanner: z.boolean(),
  miniImageUrl: z.string(),
  longDescription: z.string(),
  shortDescription: z.string(),
  termsAndConditions: z.string(),
  promoType: z.string(),
  subPromoType: z.enum(['SpinCount', 'BetAmount']),
  subTypeMeta: SubTypeMetaSchema,
  searchEngineTitle: z.string(),
  searchEngineDescription: z.string(),
  lockedDescription: z.string().optional(),
});

export const PromotionSchema = RawQuestSchema.extend({
  slug: z.string(),
});

export type Quest = z.infer<typeof PromotionSchema>;

export const InPeriodPromosResponseSchema = z.object({
  inPeriodPromos: z.array(RawQuestSchema),
});
